import angular from 'angular';
import moment from 'moment';
import 'ui-select';
import 'ng-flow';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module';
import 'angular-bootstrap-colorpicker/css/colorpicker.css';
import './webElementsServices';

const controllers = angular.module('applicationModule.webElementsControllers', [
    'applicationModule.webElementsServices',
    // 'colorpicker.module',
    'flow',
    'ui.select'
]);

controllers.controller('WebelementsController', [
    '$scope', '$rootScope', '$stateParams', '$modal', '$state', 'growl', 'Webelements', '$timeout',
    function ($scope, $rootScope, $stateParams, $modal, $state, growl, Webelements, $timeout) {
        'use strict';

        $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
        $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, 'slow');
        $scope.writeAccess = true;
        $scope.application_id = $stateParams.application_id;
        $scope.module_id = $stateParams.module_id;

        $scope.isDropped = false;

        $scope.isLoading = true;
        Webelements.all($scope.application_id, $scope.module_id)
            .then(function (response) {
                $scope.data = response.elements;
                $scope.parent_col = response.parent;
                $scope.parents = response.parents;
                $scope.module = response.module;
            })
            .finally(() => {
                $scope.isLoading = false;
            });

        $scope.create = () => {
            const modalInstance = $modal.open({
                templateUrl: 'views/application/web/elements/edit.tpl.html',
                controller: 'WebelementModalController',
                resolve: {
                    element: () => ({})
                },
                backdrop: 'static'
            });
            modalInstance.result.then(() => {
                $state.go($state.current, {}, {reload: true});
                growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.CREATED');
            }).catch(() => {});
        };

        $scope.edit = element => {
            const modalInstance = $modal.open({
                templateUrl: 'views/application/web/elements/edit.tpl.html',
                controller: 'WebelementModalController',
                resolve: {
                    element: () => element
                }
            });
            modalInstance.result.then(() => {
                $state.go($state.current, {}, {reload: true});
                growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.EDITED');
            }).catch(() => {});
        };

        $scope.removeElement = function (id, index) {
            Webelements.remove(id, $scope.module_id)
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.DELETED');
                        $scope.data.splice(index, 1);
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.DELETED');
                    }
                });
        };

        $scope.treeOptions = {
            beforeDrag: () => true,
            dropped: () => {
                $scope.isDropped = true;
                $timeout(() => {
                    $scope.saveOrder($scope.data);
                }, 1000);
            }
        };

        $scope.saveOrder = function (data) {
            var tmpData = {
                application_id: $scope.application_id,
                module_id: $scope.module_id,
                elements: data
            };

            Webelements.changeOrder(tmpData)
                .then(response => {
                    const data = response.data;
                    if (data.success) {
                        // successful changed orders
                    }
                })
                .finally(() => {
                    $scope.isDropped = false;
                });
        };

        $scope.changeOrder = function ($event, key1, key2) {
            $event.stopImmediatePropagation();
            Webelements.changeOrder({order_ids: [ $scope.data[key1].order, $scope.data[key2].order ], application_id: $scope.application_id, module_id: $scope.module_id})
                .then(function (response) {
                    if (response.data.success) {
                        var tmp_order = $scope.data[key1].order;
                        $scope.data[key1].order = $scope.data[key2].order;
                        $scope.data[key2].order = tmp_order;

                        var tmp = angular.copy($scope.data[key1]);
                        $scope.data[key1] = angular.copy($scope.data[key2]);
                        $scope.data[key2] = tmp;
                    }
                });
        };
    }
]);

controllers.controller('WebelementModalController', [
    '$scope', '$state', '$stateParams', '$modalInstance', '$modal', 'growl', 'Webelements', 'Webmodules', 'element', '$filter',
    function ($scope, $state, $stateParams, $modalInstance, $modal, growl, Webelements, Webmodules, element, $filter) {
        const appId = $stateParams.application_id;
        const moduleId = $stateParams.module_id;
        $scope.elem = {};
        $scope.elem.status = 1;

        $scope.errors = {};
        $scope.upload = {};
        $scope.fileUploaded = {};
        $scope.fileName = {};
        $scope.invalidContractor = undefined;
        $scope.lang = $filter('translate')('LANG');

        Webmodules.get(moduleId, appId)
            .then(response => {
                $scope.module = response.data.module;
            });

        if (element.id) {
            $scope.editMode = true;
            $scope.elem = angular.copy(element);
        }

        $scope.tinymceOptions = angular.getTinymceOptions($modal);

        if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
            $scope.tinymceOptions.language = $scope.lang;
            $scope.tinymceOptions.language_url = `/assets/tinymce/${$scope.lang}.js`;
        }

        $scope.isDatepickerOpen = {};

        $scope.closeCalendar = key => {
            $scope.isDatepickerOpen[key] = false;
        };

        $scope.beforeRenderCalendar = (key, $view, $dates) => {
            if ($scope.elem) {
                const draft = $scope.elem;
                let activeDate;

                if (key === 'date_from' && draft.date_to) {
                    activeDate = moment(draft.date_to);

                    angular.forEach($dates, date => {
                        if (date.localDateValue() >= activeDate.valueOf()) {
                            date.selectable = false;
                        }
                    });
                }

                if (key === 'date_to' && draft.date_from) {
                    activeDate = moment(draft.date_from).subtract(1, $view).add(1, 'minute');

                    angular.forEach($dates, date => {
                        if (date.localDateValue() <= activeDate.valueOf()) {
                            date.selectable = false;
                        }
                    });
                }
            }
        };

        Webelements.create({module_id: moduleId})
            .then(function (response) {
                $scope.inputs = response.inputs;

                angular.forEach($scope.inputs, val => {
                    if (val.type === 'checkbox') {
                        if (angular.isDefined($scope.elem[val.key])) {
                            if ($scope.elem[val.key] === 'true') {
                                $scope.elem[val.key] = true;
                            }
                            if ($scope.elem[val.key] === 'false') {
                                $scope.elem[val.key] = false;
                            }
                        }
                    }
                    if (val.type === 'importCsv') {
                        if (angular.isDefined($scope.elem[val.key]) && $scope.elem[val.key][0]) {
                            $scope.fileUploaded[val.key] = true;
                            $scope.fileName[val.key] = $scope.elem[val.key][0];
                        } else {
                            $scope.upload[val.key] = undefined;
                            $scope.fileUploaded[val.key] = false;
                        }
                    }
                    if (val.pattern) {
                        val.pattern = new RegExp(`^${val.pattern}$`);
                    }
                    if (val.type === 'number') {
                        if (angular.isDefined($scope.elem[val.key]) && !angular.isNumber($scope.elem[val.key])) {
                            $scope.elem[val.key] = parseInt($scope.elem[val.key]);
                        }
                    }
                });

            });
        $scope.autocompleteList = [];
        $scope.autocomplete = (from, text) => {
            text = text.replace('#', escape('#'));
            text = text.toLowerCase().trim();
            Webelements.autocomplete(moduleId, from, text)
                .then(response => {
                    const data = response.data;
                    if (data.success) {
                        $scope.autocompleteList = data.elements;
                    } else {
                        growl.error(`MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.${data.error}`);
                    }
                });
        };
        $scope.autocompletePerTypeList = [];
        $scope.autocompletePerType = (from, type, text) => {
            text = text.replace('#', escape('#'));
            text = text.toLowerCase().trim();
            Webelements.autocompletePerType(moduleId, from, type, text)
                .then(response => {
                    const data = response.data;
                    if (data.success) {
                        $scope.autocomplete_per_type_list = data.elements;
                    } else {
                        growl.error(`MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.${data.error}`);
                    }
                });
        };

        $scope.ok = () => {
            $scope.$broadcast('show-errors-check-validity');
            $scope.elem.module_id = moduleId;
            $scope.isLoading = true;
            Webelements.save($scope.elem, $scope.upload, $scope.editMode)
                .then(response => {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.element);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                            if (data.error.contractors) {
                                $scope.invalidContractor = data.error.contractors;
                            }
                        } else {
                            growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
                        }
                    }
                })
                .finally(() => {
                    $scope.isLoading = false;
                });
        };

        $scope.cancel = () => {
            $modalInstance.dismiss('cancel');
        };

        $scope.checkValid = name => angular.isDefinedNotNull($scope.errors[name]);

        $scope.removeFile = key => {
            delete $scope.upload[key];
            $scope.invalidContractor = undefined;
            if (angular.isDefined($scope.elem[key])) {
                delete $scope.elem[key];
            }
            $scope.fileUploaded[key] = false;
            $scope.fileName[key] = undefined;
        };

        $scope.uploadSuccess = (file, key) => {
            $scope.upload[key] = file;
            $scope.fileUploaded[key] = true;
            $scope.fileName[key] = undefined;
            $scope.$apply();
        };

        $scope.deleteDate = (fieldName, $event) => {
            $event.stopPropagation();
            delete $scope.elem[fieldName];
        };
    }
]);

export default controllers;
